<div class="form-review-information-section form-review-personal-information">
    <h3 class="form-review-information-section-title">Personal Information</h3>
    <div class="form-review-section form-review-personal-contact">
        <div class="form-review-personal-information-item">
            <%= name %>
        </div>

        <div class="form-review-personal-information-item">
            <%= form.find('#phone_number').val() %>
        </div>

        <div class="form-review-personal-information-item">
            <%= form.find('#email_address').val() %>
        </div>
    </div>


    <div class="form-review-section form-review-addresses">
        <% for(var i = 0; i < addresses.length; i++) { %>
            <%= addresses[i][0].outerHTML %>
        <% } %>
    </div>
</div>
